module.exports = __webpack_public_path__ + "img/logo-super-comics-global.bf81e2f2.png";